import {Box} from '@chakra-ui/react';
import {px} from '@eksab/theme';
import {EditablePlaygroundLineup} from './EditablePlaygroundLineup';
import {ListLineup} from './ListLineup';
import {useLineupStore} from './useLineupStore';

export function LineupView() {
  const lineupView = useLineupStore((state) => state.view);
  return lineupView === 'pitch' ? (
    <Box w={['100vw', '100%']} mx={[-(px[0] as number), 'unset']} px={[px[0], 'unset']}>
      <EditablePlaygroundLineup />
    </Box>
  ) : (
    <ListLineup hasStatsAction />
  );
}
